// 새 화면 코드 배포 알림(Layout-1.vue startVersionWatch)의 비교 — 탭이 읽은 스크립트와 지금 index.html 의 스크립트가 다른가.
// 두 쪽을 같은 꼴(<script src> 의 /js/app·chunk-vendors 경로 · 중복 0 · 정렬)로 만든다.
// 10-19: index.html 쪽만 <link rel=preload> 까지 줍어 chunk-vendors 가 두 번 → 같은 판인데도 늘 «다름» → 모든 탭에 헛 알림.
const MAIN_JS = /^\/js\/(app|chunk-vendors)[^"'\s>]*\.js$/

const normalize = (paths) => Array.from(new Set(paths.filter(p => MAIN_JS.test(p)))).sort().join('|')

/** 지금 index.html 글 → 비교 꼴. <script src> 만 본다(<link rel=preload> 는 빼고). */
export function scriptsOfHtml(html) {
  const paths = []
  const re = /<script\b[^>]*\bsrc=["']?([^"'\s>]+)/gi
  let m
  while ((m = re.exec(html || ''))) paths.push(m[1])
  return normalize(paths)
}

/** 탭이 읽은 document.scripts → 비교 꼴(origin 을 떼고 경로만). */
export function scriptsOfDocument(scripts, origin) {
  return normalize(Array.from(scripts || []).map(sc => (sc.src || '').replace(origin, '')))
}

/** 둘 다 있고 다를 때만 새 판. 어느 한쪽이 비면(못 받음·목록 없음) 조용히 false. */
export function isNewVersion(current, now) {
  return !!(current && now && now !== current)
}

/** 알림 글 — 쿠플러스 화면은 한국어(한자 0) · 쿠패스(중국 직원) 화면만 중국어. */
export function versionNoticeText(isCoupass) {
  return isCoupass
    ? { title: '更新提示', body: '有新版本，点击这里刷新页面' }
    : { title: '업데이트 안내', body: '새 버전이 나왔습니다 — 눌러서 새로고침' }
}
